import React, { useState } from "react";
import logo from "../../assets/Logo/logo.svg";
import { Link, useNavigate } from "react-router-dom";
import LoginForm from "../../app/login/loginForm";
import SignupForm from "../../app/signup/signupForm";
import LanguageSwitcher from "../language-switcher";
import { routes } from "../../Routes";
import { useTranslation } from "react-i18next";
import i18next from "i18next";

const LoginSignup = ({ welcomeText, subText, login, belowText }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  return (
    <>
      <div
        className={`absolute ${
          i18next.language === "ar" ? "left-5" : "right-5"
        } top-7 justify-end`}
      >
        <LanguageSwitcher loading={loading} setLoading={setLoading} />
      </div>
      <div className="flex flex-col items-start justify-start overflow-hidden md:px-20">
        <div
          className="flex flex-col items-start mb-2.5"
          style={{ marginTop: "rem" }}
        >
          <h1
            className="font-semibold text-gray-800  text-2xl "
            style={{ marginTop: "2rem" }}
          >
            {login == true ? t("Login") : t("Sign up")}
          </h1>
          <p className="mt-2 text-md">
            {login == true
              ? t("Don’t have an account?")
              : t("Already have an account?")}{" "}
            <span className="text-primaryBlue font-semibold">
              {login == true ? (
                <Link to={routes.signup}>{t("Sign up")}</Link>
              ) : (
                <Link to={routes.login}>{t("Login")}</Link>
              )}
            </span>
          </p>
        </div>
        {login == true ? <LoginForm setCompanyIDForPriceChecker={()=> {}} /> : <SignupForm />}
      </div>
    </>
  );
};

export default LoginSignup;
